<template>
  <div class="main">
    <Nav v-if="showTop" :key="$route.fullPath" />
    <div class="main__content">
      <keep-alive>
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Nav from "@/components/Nav/index.vue";

export default {
  components: {
    Nav
  },
  data() {
    return {
      showTop: false
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.path == '/HomePage') {
        this.showTop = false
      } else {
        this.showTop = true
      }
    }
  },
  created() {
    if (this.$route.path == '/HomePage') {
      this.showTop = false
    } else {
      this.showTop = true
    }
  },
  mounted() {
    //获取GROUPLIST
    this.doShowOrganization();
    //获取用户列表
    this.doShowUserMessage();

  },
  methods: {
    ...mapMutations(["COMMIT_GROUPLIST", "COMMIT_USERLIST", "COMMIT_TOKEN"]),
    //获取GROUPLIST
    async doShowOrganization() {
      try {
        const { data } = await this.$API.getOTree();
        if (Array.isArray(data)) {
          this.COMMIT_GROUPLIST(data);
        } else {
          this.COMMIT_GROUPLIST([data]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    //获取用户列表
    async doShowUserMessage() {
      try {
        const { data } = await this.$API.showUser();
        if (Array.isArray(data)) {
          this.COMMIT_USERLIST(data);
        } else {
          this.COMMIT_USERLIST([data]);
        }
        data && this.COMMIT_TOKEN(data.id || 'token');
      } catch (error) {
        this.COMMIT_TOKEN(null);
        console.error(error);
        // this.$msg({
        //   showClose: true,
        //   message: error.msg,
        //   type: "error"
        // });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  width: 100%;
  background: #eaedf1;
  display: flex;
  flex-direction: column;

  &__content {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
  }
}
</style>
